// extracted by mini-css-extract-plugin
module.exports = {"ErrorModal":"ErrorModal_ErrorModal__3wF-V","Open":"ErrorModal_Open__zGocf","Close":"ErrorModal_Close__TgOeH","Brand":"ErrorModal_Brand__3R_DY"};